(function (angular) {
  "use strict";

  angular.module("app").service("Auth", AuthService);

  AuthService.$inject = ["MeApi", "$rootScope", "$q"];

  function AuthService(MeApi, $rootScope, $q) {
    /**
     * Checks whether the user is signed in.
     *
     * Returns a promise, note however that the http interceptor will catch any 401s and
     * redirect the user to the signin page.
     *
     * @param {boolean} reload Force reload the user's info from the API
     * @returns {Promise<void>}
     */
    function check(reload) {
      var defer = $q.defer();

      if (!($rootScope && $rootScope.thisUser) || reload) {
        // not found or force requested, try reloading the user
        MeApi.get(
          function handleMeSuccess(response) {
            defer.resolve();
            $rootScope.setThisUser(response.data);
          },
          function handleMeError() {
            // user is not signed in...
            defer.reject();
          },
        );
      } else {
        // we have the user object so we can assume they're signed in
        defer.resolve();
      }

      return defer.promise;
    }

    return {
      check: check,
    };
  }
})(angular);
